import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  useTranslate,
  EditButton,
  DeleteButton,
  FunctionField,
  DateField,
  usePermissions,
} from 'react-admin';
import ListActions from '../../components/ListActions';
import CoursesFilter from '../../components/CoursesFilter';
import TourCourses from './TourCourses';

const CoursesList = (props) => {
  const translate = useTranslate();
  const { permissions } = usePermissions();
  return (
    <List
      {...props}
      sort={{ field: 'updatedAt', order: 'DESC' }}
      actions={
        <ListActions
          {...props}
          tourConfig={TourCourses({ translate })}
          hideFilters
        />
      }
      bulkActionButtons={permissions === 'ADMIN'}
      filters={<CoursesFilter />}
    >
      <Datagrid rowClick="edit">
        <TextField source="id" />
        <TextField source="name" label={translate('custom.general.name')} />
        <TextField source="status" label={translate('custom.general.status')} />
        <TextField
          label={translate('custom.courses.unitsLength')}
          source="units.length"
        />
        <TextField label="Precio" source="price" />
        <FunctionField
          label={translate('custom.courses.clientName')}
          render={({ clientId }) => (clientId ? clientId.name : '-')}
        />
        <FunctionField
          label={translate('custom.courses.licenseName')}
          render={({ licenseId }) => (licenseId ? licenseId.name : '-')}
        />
        <FunctionField
          label={translate('custom.courses.licenseStatus')}
          render={({ licenseId }) => (licenseId ? licenseId.status : '-')}
        />
        <DateField
          label={translate('custom.general.createdAt')}
          source="createdAt"
          showTime
        />
        <DateField
          label={translate('custom.general.updatedAt')}
          source="updatedAt"
          showTime
        />
        <EditButton data-testid="clients-edit" />
        {permissions === 'ADMIN' && (
          <DeleteButton data-testid="clients-delete" />
        )}
      </Datagrid>
    </List>
  );
};

export default CoursesList;
